import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { BatchSpanProcessor } from '@opentelemetry/sdk-trace-base';
import { resourceFromAttributes } from '@opentelemetry/resources';
import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { ZoneContextManager } from '@opentelemetry/context-zone';
import { W3CTraceContextPropagator } from '@opentelemetry/core';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { DocumentLoadInstrumentation } from '@opentelemetry/instrumentation-document-load';
import { UserInteractionInstrumentation } from '@opentelemetry/instrumentation-user-interaction';
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import {
  LoggerProvider,
  SimpleLogRecordProcessor,
} from '@opentelemetry/sdk-logs';
import { OTLPLogExporter } from '@opentelemetry/exporter-logs-otlp-http';
import {
  ATTR_SERVICE_NAME,
  ATTR_SERVICE_VERSION,
} from '@opentelemetry/semantic-conventions';

let loggerProvider: LoggerProvider | null = null;

// Check if the environment is not 'test'
if (process['env']['NODE_ENV'] !== 'test') {
  const appName = 'webshop2-frontend'; // Set the application name
  const resource = resourceFromAttributes({
    [ATTR_SERVICE_NAME]: appName,
    [ATTR_SERVICE_VERSION]: '1.0',
  });

  const tracerProvider = new WebTracerProvider({
    resource,
    spanProcessors: [
      new BatchSpanProcessor(
        new OTLPTraceExporter({
          url: 'https://collector.cluster.amcon.de:4318/v1/traces',
          headers: {
            'access-controle-allow-headers': '*',
          },
        })
      ),
      //new SimpleSpanProcessor(new ConsoleSpanExporter()), For local testing
    ],
  });

  // Register the tracer
  tracerProvider.register({
    contextManager: new ZoneContextManager(),
    propagator: new W3CTraceContextPropagator(),
  });

  registerInstrumentations({
    instrumentations: [
      new DocumentLoadInstrumentation(),
      new UserInteractionInstrumentation(),
      new XMLHttpRequestInstrumentation(),
      new FetchInstrumentation(),
    ],
  });

  // ✅ **Set Up Logger Provider for OpenTelemetry Logs**
  const logExporter = new OTLPLogExporter({
    url: 'https://collector.cluster.amcon.de:4318/v1/logs',
  });
  loggerProvider = new LoggerProvider({
    resource,
    processors: [new SimpleLogRecordProcessor(logExporter)],
  });

  // ✅ Instead, use this for cleanup in the browser
  window.onbeforeunload = async () => {
    await tracerProvider.shutdown();
    await loggerProvider!.shutdown();
  };
}

// Export loggerProvider (it will be null if in test environment)
export default loggerProvider;
